import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { noop } from 'ui-components/default-props/noop';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { Checkbox } from 'ui-components/components/checkbox';
import QuickshipCostSummarySetting from './cost-summary-section';
import { linkIDs } from '../../../services/link-service/links';
import HelpArticleLink from '../../../components/help-article-link';

import style from './style.module.less';
import messages from './messages';

const printDialogLabelLink = {
  a: (chunks) => (
    <Link data-pendo-id='/settings/workflow#set-your-default-printer' to='/settings/printing'>
      {chunks}
    </Link>
  ),
};

const renderCheckBox = (value, setValue, message) => {
  const messageWithValues = { ...message };
  if (messageWithValues.id === messages.showPrintDialogPreview.id) {
    messageWithValues.values = printDialogLabelLink;
  }

  return (
    <div
      key={messageWithValues.description}
      className={classnames(style['section-item'], style['checkbox-row'])}
      onClick={(e) => {
        e.preventDefault();
        setValue((prevValue) => !prevValue);
      }}
    >
      <Checkbox checked={value} label={<FormattedMessage {...messageWithValues} />} onChange={noop} />
    </div>
  );
};

const QuickShipSettings = ({
  setShowCostSummaryValue = noop,
  setShowErrors = noop,
  setShowLabelBatchStatus = noop,
  setShowPrintDialogPreview = noop,
  setShowWarnings = noop,
  showCostSummaryValue = '',
  showErrors = false,
  showLabelBatchStatus = false,
  showPrintDialogPreview = false,
  showWarnings = false,
}) => {
  return (
    <React.Fragment>
      <h3>
        <FormattedMessage {...messages.quickShipHeader} />
      </h3>
      <div className={style.section}>
        <div key={messages.quickShipDescription} className={classnames(style['section-item'], style['section-text'])}>
          <FormattedMessage
            {...messages.quickShipDescription}
            values={{
              a: (chunks) => <HelpArticleLink articleId={linkIDs.MarkOrdersShipped}>{chunks}</HelpArticleLink>,
            }}
          />
        </div>
        {renderCheckBox(showWarnings, setShowWarnings, messages.showWarnings)}
        {renderCheckBox(showErrors, setShowErrors, messages.showErrors)}
        <QuickshipCostSummarySetting setShowCostSummaryValue={setShowCostSummaryValue} showCostSummaryValue={showCostSummaryValue} />
        {renderCheckBox(showLabelBatchStatus, setShowLabelBatchStatus, messages.showLabelBatchStatus)}
        {renderCheckBox(showPrintDialogPreview, setShowPrintDialogPreview, messages.showPrintDialogPreview)}
      </div>
    </React.Fragment>
  );
};

QuickShipSettings.propTypes = {
  setShowCostSummaryValue: PropTypes.func,
  setShowErrors: PropTypes.func,
  setShowLabelBatchStatus: PropTypes.func,
  setShowPrintDialogPreview: PropTypes.func,
  setShowWarnings: PropTypes.func,
  showCostSummaryValue: PropTypes.string,
  showErrors: PropTypes.bool,
  showLabelBatchStatus: PropTypes.bool,
  showPrintDialogPreview: PropTypes.bool,
  showWarnings: PropTypes.bool,
};

export default QuickShipSettings;
